export default {
    browser_title: "Kevi | Respostas",
    page_title: "Respostas",
    messages_counter: "{0} de {1} respostas",
    empty_state: "Nenhuma resposta encontrada.",
    filters: {
        period: "Período",
        client_segments: "Segmento do cliente",
        automations: "Automação",
        read_state: "Situação de leitura",
        select_read_state: "Lidas e não lidas",
        unread: "Não lidas",
        read: "Lidas",
        tags: "Tag",
    },
    unread: "Não lida",
    mark_read: "Marcar como lida",
    mark_all_read: "Marcar todas como lidas",
    type_emotion: "Emoção",
    type_nps: "NPS",
    type_ces: "CES",
    type_boolean: "Sim/Não",
    type_comment: "Comentário",
    type_input: "Texto",
    type_selectbox: "Seleção",
    type_date: "Data",
    type_file: "Arquivo",
    notification_all_read: "Todas as respostas foram marcadas como lidas",
    notification_marked_read: "Resposta marcada como lida",
    notification_marked_unread: "Resposta marcada como não lida",
    notification_read_failed: "Não foi possível atualizar o status de leitura",
    message: {
        back: "Voltar",
        confirm_delete_title: "Tem certeza que deseja excluir esta anotação?",
        confirm_delete_body: "Esta ação não pode ser desfeita.",
        form_label: "Formulário",
        form_title: "Formulário {0}",
        filled_on: "Preenchido em",
        answers_report_title: "Relatório de Respostas",
        answers_title: "Respostas",
        purchases_label: "Compras",
        phone_label: "Telefone",
        email_label: "E-mail",
        external_id_label: "ID externo",
        last_purchase_label: "Última compra",
        not_informed: "Não informado",
        spend_summary: "R$ {0} gastos em {1} pedidos",
        no_purchase_data: "Não há dados de compras",
        mark_unread: "Marcar como não lida",
        view_client: "Ver cliente",
        more_actions: "Mais ações",
        edit_answers: "Editar respostas",
        duplicate_answer: "Duplicar resposta",
        delete_answer: "Excluir resposta",
        create_task: "Criar tarefa",
        create_task_title: "Criar tarefa a partir da resposta",
        create_task_name: "Título",
        create_task_name_placeholder: "Título da tarefa",
        create_task_board: "Quadro",
        create_task_board_placeholder: "Nenhum (opcional)",
        create_task_stage: "Estágio",
        create_task_stage_placeholder: "Selecione o estágio",
        create_task_assignee: "Responsável",
        create_task_assignee_placeholder: "Selecione o responsável",
        create_task_due_date: "Prazo",
        create_task_description: "Descrição",
        create_task_action: "Criar tarefa",
        create_task_default_title: "Nova tarefa",
        create_task_default_description: "Cliente: {0}",
        confirm_delete_answer_title: "Excluir esta resposta?",
        confirm_delete_answer_body:
            "A resposta será ocultada da listagem. Essa ação pode ser revertida apenas com suporte.",
        edit_modal_title: "Editar respostas",
        duplicate_modal_title: "Duplicar resposta",
        edit_save: "Salvar alterações",
        duplicate_save: "Duplicar e salvar",
        notification_duplicated: "Resposta duplicada com sucesso",
        notification_duplicate_error: "Não foi possível duplicar a resposta",
        notification_deleted: "Resposta excluída",
        notification_delete_error: "Não foi possível excluir a resposta",
        notification_edited: "Respostas atualizadas",
        notification_edit_error: "Não foi possível salvar as alterações",
        notification_task_created: "Tarefa criada com sucesso",
        notification_task_create_error: "Não foi possível criar a tarefa",
        tags_label: "Tags",
        add_tag: "Adicionar tag",
        tag_placeholder: "Selecione uma etiqueta ou digite",
        create_tag: "Criar",
        tag_empty: "Nenhuma tag ainda. Digite para criar.",
        edit_tag: "Editar tag",
        select_tag_color: "Selecione uma cor",
        delete_tag: "Deletar",
        no_tags_available: "Nenhuma tag configurada para este formulário",
        notification_tag_applied: "Tag aplicada",
        notification_tag_removed: "Tag removida",
        notification_tag_error: "Não foi possível atualizar a tag",
        bool_yes: "Sim",
        bool_no: "Não",
        unanswered: "Sem resposta",
        no_files: "Nenhum arquivo enviado",
        remove_file: "Remover",
        upload_files: "Adicionar arquivos",
        uploading_files: "Enviando...",
        upload_files_error: "Não foi possível enviar o arquivo",
        upload_files_too_many: "Você pode anexar no máximo {0} arquivos",
        nps_promoter: "Promotor",
        nps_neutral: "Neutro",
        nps_detractor: "Detrator",
        ces_easy: "Fácil",
        ces_medium: "Aceitável",
        ces_hard: "Difícil",
        linked_tasks_title: "Tarefas vinculadas",
        linked_task_open: "Em aberto",
        linked_task_unassigned: "Sem responsável",
        notes_title: "Comentários",
        edit_note: "Editar comentário",
        delete_note: "Excluir comentário",
        save: "Salvar",
        cancel: "Cancelar",
        note_placeholder:
            "Escreva aqui o que você fez ou pretende fazer em relação a esse feedback",
        add_note: "Comentar",
        notification_note_saved: "Comentário salvo com sucesso",
        notification_note_empty: "A anotação não pode estar vazia",
        notification_note_updated: "Comentário atualizado com sucesso",
        notification_note_update_error: "Erro ao atualizar anotação",
        notification_note_deleted: "Comentário excluído com sucesso",
        notification_note_delete_error: "Erro ao excluir anotação",
    },
};
